<template>
  <div>
    <div>
      <div class="row">
        <div class="col-3 form-group">
          <label>Template</label>
          <select class="form-control" v-model="advanced_visual.template_id">
            <option :value="1">Standard</option>
            <option :value="5">Standard Full</option>
            <option :value="3">Two Column</option>
            <option :value="4">Two Column w/ Header</option>
            <option :value="6">Three Column w/ Header</option>
            <option :value="7">Two Row</option>
            <option :value="8">Three Row</option>
            <option :value="9">2 x 2 Grid</option>
            <option :value="10">2 x 3 Grid</option>
            <option :value="11">3 x 2 Grid</option>
            <option :value="2">Blank</option>
          </select>
        </div>

        <div class="col-2 form-group">
          <label>Image Resolution</label>
          <select class="form-control" v-model="preview_settings.preset_resolution" @change="changePresetResolution">
            <option value="1280x720">1280x720</option>
            <option value="1536x864">1536x864</option>
            <option value="1600x900">1600x900</option>
            <option value="1920x1080">1920x1080</option>
            <option value="2560x1440">2560x1440</option>
          </select>
        </div>

        <div class="col-2 form-group">
          <label>Background Color</label>
          <input class="form-control" type="color" v-model="advanced_visual.background_color" />
        </div>

        <div class="col-2 form-group">
          <label>Background Image</label>
          <select class="form-control" v-model="advanced_visual.background_image_id" >
            <option :value="null">No background selected</option>
            <option v-for="image in filtered_images" :value="image.image_id">{{ image.name }}</option>
          </select>
        </div>

        <div class="col-1 form-group">
          <label>Show Unavailable Sections?</label>
          <input class='form-check' type="checkbox" v-model="preview_settings.show_unavailable_sections" />
        </div>

        <div class="col-4 form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="advanced_visual.name" />
        </div>

      </div>

      <div class="form-group">
        <button type="button" class="btn btn-hub-primary" :disabled="loading" @click="submit()">
          Save
          <span v-if="loading" class="spinner-border spinner-border-sm"></span>
        </button>
        <button type="button" class="btn btn-secondary" :disabled="loading" @click="reset()">
          Reset
        </button>
        <router-link type="button" class="btn btn-secondary" :disabled="loading"
          :to="{ name: 'EventSummary', params: { event_id } }">
          Cancel
        </router-link>
        <button type="button" class="btn btn-primary ml-3" @click="showSelectVisualModal">
          Copy existing visual
        </button>
      </div>
    </div>

    <div :style="{
      'background-color': advanced_visual.background_color,
      'aspect-ratio': '16 / 9',
      width: '100%',
      'font-size': '1vw'
    }">
      <div class="row h-100" v-if="advanced_visual.template_id === 1"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key" :tinymce-script-src="tinymceScriptSrc"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div :class="{
              'col-1': true,
              'visual-section': true,
              'visual-unavailable-section':
                preview_settings.show_unavailable_sections,
            }"></div>
            <div class="col-10 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div :class="{
              'col-1': true,
              'visual-section': true,
              'visual-unavailable-section':
                preview_settings.show_unavailable_sections,
            }"></div>
          </div>
          <div class="row h-25">
            <div class="col-6 text-left visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content5" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 2"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-100">
            <div class="col-12 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 4"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-12 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-75">
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 3"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-100">
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 5"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-12 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-25">
            <div class="col-6 text-left visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 text-right visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content5" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 6"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-left">
            <div class="col-12 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-75">
            <div class="col-4 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 7"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-50 text-center">
            <div class="col-12 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-12 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>

      <div class="row h-100" v-if="advanced_visual.template_id === 8"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-center">
            <div class="col-12 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-12 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-25 text-center">
            <div class="col-12 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>

      <div class="row h-100" v-if="advanced_visual.template_id === 9"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-50 text-center">
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 10"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-50 text-center">
            <div class="col-4 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-4 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content5" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-4 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content6" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


      <div class="row h-100" v-if="advanced_visual.template_id === 11"
        :style="background_style"
      >
        <div class="col-12">
          <div class="row h-25 text-center">
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content3" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content4" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content1" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content2" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
          <div class="row h-25">
            <div class="col-6 text-center visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content5" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
            <div class="col-6 visual-section">
              <editor inline v-model="advanced_visual.resolutions[0].content6" :api-key="tinyMCEGlobalConfig.api_key"
                :init="tinyMCETextConfig.init" class="custom-editor">
              </editor>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="shadow-container">
      <div class="visual-shadow" :id="`visual-shadow-${advanced_visual.advanced_visual_id}`" :style="{
        'background-color': advanced_visual.background_color,
        width: `${preview_settings.width}px`,
        height: `${preview_settings.height}px`,
        'font-size': `${0.01 * preview_settings.width}px`
      }">
        <div class="row h-100" v-if="advanced_visual.template_id === 1"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-6 visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
              <div class="col-6 text-right visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
            </div>
            <div class="row h-50">
              <div :class="{
                'col-1': true,
                'visual-section': true,
              }"></div>
              <div class="col-10 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div :class="{
                'col-1': true,
                'visual-section': true,
              }"></div>
            </div>
            <div class="row h-25">
              <div class="col-6 text-left visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
              <div class="col-6 text-right visual-section">
                <div class="visual-content" id="content5"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 2"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-100">
              <div class="col-12 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 4"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-12 visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
            </div>
            <div class="row h-75">
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 3"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-100">
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 5"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-6 visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
              <div class="col-6 text-right visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-12 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
            </div>
            <div class="row h-25">
              <div class="col-6 text-left visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
              <div class="col-6 text-right visual-section">
                <div class="visual-content" id="content5"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 6"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-left">
              <div class="col-12 visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
            </div>
            <div class="row h-75">
              <div class="col-4 text-center visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
              <div class="col-4 text-center visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
              <div class="col-4 text-center visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 7"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-50 text-center">
              <div class="col-12 visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-12 text-center visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 8"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-center">
              <div class="col-12 visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-12 text-center visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
            <div class="row h-25 text-center">
              <div class="col-12 visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 9"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-50 text-center">
              <div class="col-6 visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div class="col-6 visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
              <div class="col-6 visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 10"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-50 text-center">
              <div class="col-4 visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div class="col-4 visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
              <div class="col-4 visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-4 text-center visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
              <div class="col-4 visual-section">
                <div class="visual-content" id="content5"></div>
              </div>
              <div class="col-4 visual-section">
                <div class="visual-content" id="content6"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row h-100" v-if="advanced_visual.template_id === 11"
          :style="background_style"
        >
          <div class="col-12">
            <div class="row h-25 text-center">
              <div class="col-6 visual-section">
                <div class="visual-content" id="content3"></div>
              </div>
              <div class="col-6 visual-section">
                <div class="visual-content" id="content4"></div>
              </div>
            </div>
            <div class="row h-50">
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content1"></div>
              </div>
              <div class="col-6 visual-section">
                <div class="visual-content" id="content2"></div>
              </div>
            </div>
            <div class="row h-25">
              <div class="col-6 text-center visual-section">
                <div class="visual-content" id="content5"></div>
              </div>
              <div class="col-6 visual-section">
                <div class="visual-content" id="content6"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Modal modal_id="selectVisualModal" size="md">
      <template #title>
        Select an existing visual
      </template>
      <template #body>
        <div class="form-group">
          <label for="ddlVisuals">Visual</label>
          <div class="input-group">
            <select class="form-control" id="ddlVisuals" v-model="template_id">
              <option :value=null>Select..</option>
              <option v-for="advanced_visual in filtered_advanced_visuals" :key="advanced_visual.advanced_visual_id"
                :value="advanced_visual.advanced_visual_id">[{{ getEventName(advanced_visual.event_id) }}] {{ advanced_visual.name }}</option>
            </select>
          </div>
        </div>
        <div v-if="template_id">
          <AdvancedVisualPreview :advanced_visual="getVisual(template_id)" />
        </div>
        <div class="text-right">
          <button class="btn btn-hub-primary mt-2" @click="importFromVisual">Import</button>
        </div>
      </template>
    </Modal>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '../../../router'
import Editor from '@tinymce/tinymce-vue'
import * as htmlToImage from 'html-to-image'
import AdvancedVisualPreview from '../../Visual/AdvancedVisualPreview'
import Modal from '../../Modal'
import { EVENT_TYPE } from '../../../assets/js/resource-types'

export default {
  props: {
    event_id: { type: [Number, String], required: true }
  },
  components: {
    editor: Editor,
    AdvancedVisualPreview,
    Modal
  },
  computed: {
    ...mapGetters({
      images: 'allImages',
      event: 'singleEvent',
      events: 'allEvents',
      advanced_visuals: 'allAdvancedVisuals',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled'
    }),
    filtered_images() {
      const eventType = this.event.event_type_id === EVENT_TYPE['Alert'] ? 'alert' : 'announcement'
      return this.images.filter(img => img.tags.includes(eventType))
    },
    filtered_advanced_visuals() {
      const eventType = this.event.event_type_id === EVENT_TYPE['Alert'] ? 'alert' : 'announcement'
      const eventIds = this.events.filter(e => e.event_type_id === this.event.event_type_id).map(e => e.event_id)
      return this.advanced_visuals.filter(v => eventIds.includes(v.event_id))
    },
    background_image_filename() {
      if(this.advanced_visual.background_image_id) {
        return this.images.find(img => img.image_id === this.advanced_visual.background_image_id).filename
      }
    },
    background_style() {
      if(this.background_image_filename) {
        return {
          'background-color': this.advanced_visual.background_color,
          'background-image': `url('/upload/images/visual_backgrounds/${this.background_image_filename}')`,
          'background-position': 'center',
          'background-size': '100% 100%',
          'background-repeat': 'no-repeat',
        }
      }
      return {
        'background-color': this.advanced_visual.background_color,
      }
    }
  },
  data: function () {
    return {
      loading: false,
      preview_settings: {
        preset_resolution: '1280x720',
        width: 1280,
        height: 720,
        show_unavailable_sections: true
      },
      tinymceScriptSrc: "//cdnjs.cloudflare.com/ajax/libs/tinymce/5.7.0/tinymce.min.js",
      tinyMCEGlobalConfig: {
        api_key: 'km7w4ez9zfk44ezxsvkbo9ql09woqny2cjlh4cshcnugiv57'
      },
      tinyMCETextConfig: {
        init: {
          menubar: false,
          fontsize_formats: '100% 200% 300% 400% 500% 600%',
          plugins: [
            'advlist lists link image charmap preview anchor',
            'searchreplace emoticons media paste',
            'template'
          ],
          toolbar_mode: 'wrap',
          toolbar: [
            'undo redo | bold italic underline backcolor forecolor | fontsizeselect',
            'alignleft aligncenter alignright alignjustify | link image media emoticons | fontselect',
            'bullist numlist outdent indent | strikethrough subscript superscript | removeformat'
          ],
          automatic_uploads: true,
          images_upload_url:
            location.origin + '/api/advanced_visual_image_upload',
          images_reuse_filename: true,
          file_picker_types: 'image',
          file_picker_callback: function (cb, value, meta) {
            var input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/*')

            input.onchange = function () {
              var file = this.files[0]

              var reader = new FileReader()
              reader.onload = function () {
                var id = 'blobid' + new Date().getTime()
                var blobCache = tinymce.activeEditor.editorUpload.blobCache
                var base64 = reader.result.split(',')[1]
                var blobInfo = blobCache.create(id, file, base64)
                blobCache.add(blobInfo)

                cb(blobInfo.blobUri(), { title: file.name })
              }
              reader.readAsDataURL(file)
            }

            input.click()
          },
          content_style: 
            "p { line-height: 1; margin: 0; padding: 0; }" + 
            ".center { height: 100%; width: 100%; display: flex; align-items: center; justify-content: center; }" +
            ".font-300 { font-size: 300% }" + 
            ".font-400 { font-size: 400% }" + 
            ".font-500 { font-size: 500% }"
        }
      },
      advanced_visual: {
        advanced_visual_id: 0,
        template_id: 1,
        event_id: this.event_id,
        name: '',
        background_color: '#FFFFFF',
        background_image_id: null,
        resolutions: [
          {
            resolution: '1280x720',
            content1: '<p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><span style="font-size: 300%;">A Test Alert</span></p>',
            content2: '',
            content3: '',
            content4: '',
            content5: '',
            content6: ''
          }
        ]
      },
      template_id: null
    }
  },
  methods: {
    showSelectVisualModal() {
      $('#selectVisualModal').modal('show')  //eslint-disable-line
    },
    getVisual(advancedVisualId) {
      return this.advanced_visuals.find(av => av.advanced_visual_id === advancedVisualId)
    },
    getEventName(eventId) {
      return this.events.find(e => e.event_id === eventId).name
    },
    importFromVisual() {
      if(!this.template_id) {
        alert('Please select a visual')
        return
      }

      this.advanced_visual = { ...this.getVisual(this.template_id) }
      this.advanced_visual.advanced_visual_id = 0
      this.advanced_visual.event_id = this.event.event_id
      this.advanced_visual.name = ''
      $('#selectVisualModal').modal('hide')  //eslint-disable-line
    },
    changeBackgroundColor(data) {
      this.advanced_visual.background_color = data.hex
    },
    changePresetResolution() {
      const [width, height] = this.preview_settings.preset_resolution.split('x')
      this.preview_settings.width = width
      this.preview_settings.height = height
      this.advanced_visual.resolutions[0].resolution = this.preview_settings.preset_resolution
    },
    generateImage(advancedVisualResolutions) {
      const node = document.getElementById(`visual-shadow-${this.advanced_visual.advanced_visual_id}`)
      const contentNodes = node.querySelectorAll('.visual-content')

      contentNodes.forEach(node => {
        node.innerHTML = advancedVisualResolutions[node.id]
      })

      return htmlToImage.toPng(node, { pixelRatio: 1, fontEmbedCSS: false })
        .catch(function (error) {
          console.error('oops, something went wrong!', error)
        });
    },
    submit() {
      this.loading = true;

      this.generateImage(this.advanced_visual.resolutions[0])
        .then(dataUrl => {
          this.advanced_visual.data_url = dataUrl
          return this.$store.dispatch('addEditAdvancedVisual', { advanced_visual: this.advanced_visual, next: null })
        })
        .then((newVisual) => {
          if (newVisual) this.$router.push({ name: 'EventSummary', params: { event_id: this.event_id } })
          else this.loading = false;
        })
        .catch(err => { console.log(err); this.loading = false })
    },
    reset() {
      this.advanced_visual = {
        advanced_visual_id: 0,
        template_id: 1,
        event_id: this.event_id,
        name: '',
        background_color: '#FFFFFF',
        background_image_id: null,
        resolutions: [
          {
            resolution: '1280x720',
            content1: '<p style="text-align: center;">&nbsp;</p> <p style="text-align: center;">&nbsp;</p> <p style="text-align: center;"><span style="font-size: 300%;">A Test Alert</span></p>',
            content2: '',
            content3: '',
            content4: '',
            content5: '',
            content6: ''
          }
        ]
      }
    }
  },
  created() {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')

    if (!this.feature_visual_alert_enabled) {
      router.push({ name: 'EventSummary', params: { event_id: this.event_id } })
    }

    this.$store.dispatch('getEvent', this.event_id)
    this.$store.dispatch('getImages')
  }
}
</script>

<style scoped>
.custom-editor {
  height: 100%;
}

.visual-section {
  border: 1px dashed black;
}

.shadow-container {
  height: 0px;
  overflow: hidden;
}

.shadow-container .visual-section {
  border: none;
}

.visual-unavailable-section {
  background: repeating-linear-gradient(45deg,
      #d61c1c,
      #d61c1c 10px,
      #ffffff 15px,
      #ffffff 30px);
}


.center {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.font-300 {
  font-size: 300%;
}

.font-400 {
  font-size: 400%;
}

.font-500 {
  font-size: 500%;
}
</style>
